import { NativeModules, Platform } from 'react-native';

const model = NativeModules.InfoModule?.getConstants()?.deviceModel;

export const isIphoneDuo = Platform.OS === 'ios' && model === 'iPhone19,4';
